import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tx-loader-wrapper',
  templateUrl: './loader-wrapper.component.html',
  styleUrls: ['./loader-wrapper.component.scss'],
})
export class LoaderWrapperComponent implements OnInit {
  @Input() public isLoading: boolean | null = false;
  @Input() public bgColor: string = '#FFFFFF';

  constructor() {}

  ngOnInit(): void {}
}
